import { useEffect, useState } from "react";

export function useInstallInvitationSpace(): {
  ready: boolean;
  blocked: boolean;
  auth: boolean;
} {
  const [space, setSpace] = useState({
    ready: false,
    blocked: true,
    auth: false,
  });
  useEffect(() => {
    let ready = false;
    const inspect = () => {
      const focused = document.activeElement;
      const editing =
        focused instanceof HTMLElement &&
        focused.matches("input, textarea, select, [contenteditable=true]");
      const blocked =
        document.hidden ||
        editing ||
        Boolean(
          document.querySelector(
            '[role="dialog"], [aria-modal="true"], .fr-loading, .fr-score-live, .rwz-page, .ggb-overlay',
          ),
        ) ||
        /^\/(scorecard|tee-off|privacy)(\/|$)/.test(location.pathname);
      const auth = Boolean(document.querySelector(".fr-auth-page"));
      setSpace((previous) =>
        previous.ready === ready &&
        previous.blocked === blocked &&
        previous.auth === auth
          ? previous
          : { ready, blocked, auth },
      );
    };
    const timer = window.setTimeout(() => {
      ready = true;
      inspect();
    }, 5000);
    const observer = new MutationObserver(inspect);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["aria-modal", "data-state"],
    });
    document.addEventListener("focusin", inspect);
    document.addEventListener("focusout", inspect);
    document.addEventListener("visibilitychange", inspect);
    window.addEventListener("popstate", inspect);
    inspect();
    return () => {
      clearTimeout(timer);
      observer.disconnect();
      document.removeEventListener("focusin", inspect);
      document.removeEventListener("focusout", inspect);
      document.removeEventListener("visibilitychange", inspect);
      window.removeEventListener("popstate", inspect);
    };
  }, []);
  return space;
}
